import { deriveCurrency } from './track';

export type PaymentGateway = 'stripe' | 'wipay' | 'fygaro';

interface CourierGatewayInfo {
  stripeCredentials?: { isStripeApiEnabled?: boolean } | null;
  wipayCredentials?: { isWipayApiEnabled?: boolean } | null;
  courierSetting?: { isFygaroApiEnabled?: boolean } | null;
}

/**
 * Resolve which payment gateway the courier uses, in the same priority order the
 * payment-link builders use (stripe → wipay → fygaro).
 */
export const resolvePaymentGateway = (
  courier: CourierGatewayInfo | null | undefined
): PaymentGateway | null => {
  if (courier?.stripeCredentials?.isStripeApiEnabled) return 'stripe';
  if (courier?.wipayCredentials?.isWipayApiEnabled) return 'wipay';
  if (courier?.courierSetting?.isFygaroApiEnabled) return 'fygaro';
  return null;
};

/**
 * Build the `payment_initiated` analytics params (value + currency + gateway).
 */
export const buildPaymentInitiatedParams = (input: {
  value: number;
  courierSetting?: { useJmd?: boolean } | null;
  paymentGateway: PaymentGateway | null;
  invoiceCount: number;
}): Record<string, unknown> => ({
  value: input.value,
  currency: deriveCurrency(input.courierSetting),
  payment_gateway: input.paymentGateway,
  invoice_count: input.invoiceCount,
});
